// extracted by mini-css-extract-plugin
export var orderDetails = "_tx-2";
export var orderImage = "_tx-1";
export var orderMeta = "_tx-3";
export var orderSummary = "_tx-0";
export var rightArrow = "_tx-4";